<img
  class="seal"
  alt="Guaranty seal"
  [attr.data-e2e]="'guaranty-seal'"
  [src]="
    'guaranty-seals/' + lang + '/' + art + '-' + (refund_days$ | async) + '.png'
      | orderformAsset
  "
/>
